import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  useEffect(() => { document.title = "Compra exitosa — XCARET MEXICO"; }, []);
  return (
    <div className="min-h-screen bg-jungle flex items-center justify-center px-6 grain relative text-center">
      <div className="relative max-w-lg">
        <div className="flex justify-center mb-8"><Logo variant="light" /></div>
        <CheckCircle2 size={64} className="text-teal mx-auto mb-6" />
        <h1 className="font-heading text-4xl font-semibold text-sand mb-4">¡Gracias por tu compra!</h1>
        <p className="font-body text-sand/70 mb-8">
          Tu pago fue procesado por Whop. En breve recibirás la confirmación de tu paquete y nuestro equipo te contactará para coordinar los detalles de tu servicio.
        </p>
        <Link to="/" className="inline-flex items-center gap-2 bg-teal text-sand hover:bg-teal-dark font-body px-8 py-4 transition-colors" data-testid="success-home-link">
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
